/* istanbul ignore file */
export { default } from './DateOfBirth';
